"use client";

import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from "@tanstack/react-query";
import { KeyRound, LayoutDashboard, LogOut, Users } from "lucide-react";
import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { Sidebar, SidebarContent, SidebarFooter, SidebarGroup, SidebarGroupLabel, SidebarHeader, SidebarInset, SidebarMenu, SidebarMenuButton, SidebarMenuItem, SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { useAuth } from "@/lib/auth-client";
import { Logo } from "./ui/logo";
import type { ReactNode } from "react";
interface AdminShellProps {
  children: ReactNode;
}
export function AdminShell(t0) {
  const $ = _c(34);
  const {
    children
  } = t0;
  const pathname = usePathname();
  const router = useRouter();
  const {
    signOut
  } = useAuth();
  const queryClient = useQueryClient();
  const isDashboard = pathname === "/" || pathname === "";
  const isTokens = pathname === "/tokens";
  let t1;
  if ($[0] !== queryClient || $[1] !== router || $[2] !== signOut) {
    t1 = async () => {
      await signOut({
        fetchOptions: {
          onSuccess: () => {
            queryClient.clear();
            router.push("/login");
          }
        }
      });
    };
    $[0] = queryClient;
    $[1] = router;
    $[2] = signOut;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSignOut = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex h-7 w-7 items-center justify-center rounded-md bg-primary/10 text-primary"><Logo className="h-4 w-4" /></div>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SidebarHeader className="border-b border-sidebar-border/60"><div className="flex h-12 items-center justify-between px-2"><div className="flex items-center gap-2 px-1">{t2}<div className="flex flex-col"><span className="text-sm font-semibold leading-tight">AndAI LLM Hub</span><span className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">Admin</span></div></div><SidebarTrigger /></div></SidebarHeader>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SidebarGroupLabel>Main</SidebarGroupLabel>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <LayoutDashboard className="h-4 w-4" />;
    t6 = <span>Dashboard</span>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isDashboard) {
    t7 = <Link href="/" className="block"><SidebarMenuButton isActive={isDashboard} size="lg">{t5}{t6}</SidebarMenuButton></Link>;
    $[9] = isDashboard;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <KeyRound className="h-4 w-4" />;
    t9 = <span>Tokens</span>;
    $[11] = t8;
    $[12] = t9;
  } else {
    t8 = $[11];
    t9 = $[12];
  }
  let t10;
  if ($[13] !== isTokens) {
    t10 = <Link href="/tokens" className="block"><SidebarMenuButton isActive={isTokens} size="lg">{t8}{t9}</SidebarMenuButton></Link>;
    $[13] = isTokens;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t7) {
    t11 = <SidebarGroup>{t4}<SidebarMenu><SidebarMenuItem>{t7}{t10}</SidebarMenuItem></SidebarMenu></SidebarGroup>;
    $[15] = t10;
    $[16] = t7;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <SidebarGroupLabel>People</SidebarGroupLabel>;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <SidebarGroup>{t12}<SidebarMenu><SidebarMenuItem><SidebarMenuButton size="lg" asChild={true}><div className="flex w-full items-center gap-2 text-sidebar-foreground/80 hover:text-sidebar-accent-foreground"><Users className="h-4 w-4" /><span>Users (coming soon)</span></div></SidebarMenuButton></SidebarMenuItem></SidebarMenu></SidebarGroup>;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t11) {
    t14 = <SidebarContent>{t11}{t13}</SidebarContent>;
    $[20] = t11;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  let t16;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <LogOut className="h-3.5 w-3.5" />;
    t16 = <span>Sign out</span>;
    $[22] = t15;
    $[23] = t16;
  } else {
    t15 = $[22];
    t16 = $[23];
  }
  let t17;
  if ($[24] !== handleSignOut) {
    t17 = <SidebarFooter className="border-t border-sidebar-border/60"><Button variant="ghost" size="sm" className="w-full justify-start gap-2 text-xs text-muted-foreground" onClick={handleSignOut}>{t15}{t16}</Button></SidebarFooter>;
    $[24] = handleSignOut;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== t14 || $[27] !== t17) {
    t18 = <Sidebar variant="inset">{t3}{t14}{t17}</Sidebar>;
    $[26] = t14;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== children) {
    t19 = <SidebarInset>{children}</SidebarInset>;
    $[29] = children;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t18 || $[32] !== t19) {
    t20 = <SidebarProvider>{t18}{t19}</SidebarProvider>;
    $[31] = t18;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  return t20;
}